import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

import specializedLogo from "../../../../assets/imgs/services/international/specialized.svg";
import generalLogo from "../../../../assets/imgs/services/international/general.svg";
import expressLogo from "../../../../assets/imgs/services/international/express.svg";
import customizedLogo from "../../../../assets/imgs/services/international/customized.svg";

import specializedCover from "../../../../assets/imgs/services/international/specialized.jpg";
import generalCover from "../../../../assets/imgs/services/international/general.jpg";
import expressCover from "../../../../assets/imgs/services/international/express.jpg";
import customizedCover from "../../../../assets/imgs/services/international/customized.jpg";
import "./international-home.css";

function InternationalHome() {
  const { t, i18n } = useTranslation("international");
  const [tSMetaData] = useTranslation("metaData");

  const dataInternational = t("data", { returnObjects: true }) || [];

  const lng = localStorage.getItem("lng") === "us" ? "us" : "es";
  const nav = lng === "us" ? navBarEn : navBarEs;
  const internationalBase = `/${nav["category-services"].services}/${
    Object.keys(nav["products-submenu"])[1]
  }`;
  const productSlugs = Object.keys(
    lng === "us"
      ? nav["products-international-submenu"]
      : nav["products-internacional-submenu"]
  );

  const cardAssets = [
    {
      id: 1,
      titleLogo: expressLogo,
      coverImg: expressCover,
      link_es: "/servicios/internacional/express",
      link_en: "/services/international/express",
      text: "Para su embarque, ofrecemos una confianza y seguridad inigualables, especialmente cuando el tiempo es apremiante.",
      link: `${internationalBase}/${productSlugs[0]}`
    },
    {
      id: 2,
      titleLogo: generalLogo,
      coverImg: generalCover,
      link_es: "/servicios/internacional/general",
      link_en: "/services/international/general",
      text: "Para su embarque, ofrecemos una confianza y seguridad inigualables, especialmente cuando el tiempo es apremiante.",
      link: `${internationalBase}/${productSlugs[1]}`
    },
    {
      id: 3,
      titleLogo: specializedLogo,
      coverImg: specializedCover,
      text: "Para su embarque, ofrecemos una confianza y seguridad inigualables, especialmente cuando el tiempo es apremiante.",
      link: `${internationalBase}/${productSlugs[2]}`,
      link_es: "/servicios/internacional/especializado",
      link_en: "/services/international/specialized",
    },
    {
      id: 4,
      titleLogo: customizedLogo,
      coverImg: customizedCover,
      text: "Para su embarque, ofrecemos una confianza y seguridad inigualables, especialmente cuando el tiempo es apremiante.",
      link: `${internationalBase}/${productSlugs[3]}`,
      link_es: "/servicios/internacional/customizado",
      link_en: "/services/international/customized"
    }
  ];

  useEffect(() => {
    sessionStorage.setItem(
      "routeEs",
      `/${navBarEs["category-services"].services}/${
        Object.keys(navBarEs["products-submenu"])[1]
      }`
    );

    sessionStorage.setItem(
      "routeEn",
      `/${navBarEn["category-services"].services}/${
        Object.keys(navBarEn["products-submenu"])[1]
      }`
    );
  }, []);

  // Idioma actual (soporta 'en', 'us' o 'es')
  const currentLanguage = i18n.language || localStorage.getItem("lng") || "es";
  const isEnglish = currentLanguage.includes("en") || currentLanguage.includes("us")

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[1]
    }`,
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[1]
    }`,
  );

  return (
    <>
      <Helmet>
        <title>{tSMetaData("internacionales.title")}</title>
        <meta
          name="description"
          content={tSMetaData("internacionales.description")}
        />
      </Helmet>
      <div className="container-fluid padding-international">
        <div className="row">
          {cardAssets.map((asset, index) => {
            // Se toma el texto traducido del JSON según la posición (index)
            const translatedItem = dataInternational[index] || {};

            return (
              <div className="col-12 col-lg-3 mb-5" key={asset.id}>
                <div className="international-card mx-auto">
                  {/* Imagen de portada */}
                  <div className="international-card-img-wrapper">
                    <img
                      src={asset.coverImg}
                      alt="Service Cover"
                      className="img-fluid international-cover-img"
                    />
                  </div>

                  {/* Cuerpo de la tarjeta */}
                  <div className="international-card-content">
                    <img
                      src={asset.titleLogo}
                      alt="Service Logo"
                      className="international-service-logo mb-3"
                    />

                    {/* Texto traducido dinámicamente desde el JSON */}
                    <p className="international-service-text">
                      {translatedItem.texto}
                    </p>

                    {/* Botón/Enlace traducido dinámicamente */}
                    <Link
                      to={isEnglish ? asset.link_en : asset.link_es}
                      className="international-service-link"
                    >
                      {translatedItem["texto-botón-linea"] || t("btn-learn-more")}
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default InternationalHome;
